import './index.css';
// import "./providers/wdyr/index.ts";
import './providers/i18n';

import LogoSvg from '@icons/logo.svg?react';
import { applyThemeColors } from '@shared/hooks/useDynamicThemeColor';
import LoadingScreen from '@shared/ui/LoadingScreen/LoadingScreen.tsx';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router/dom';

import index from './providers/routes';
import { store } from './store/store.ts';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <Suspense
        fallback={
          <LoadingScreen
            visible={true}
            spinner={<LogoSvg className="fill-current h-8 w-8" />}
            fullScreen={true}
            loadingText="Loading..."
          />
        }
      >
        <RouterProvider router={index} />
      </Suspense>
    </Provider>
  </React.StrictMode>,
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      // Apply initial theme colors for PWA
      const savedTheme = localStorage.getItem('theme') ?? 'light';
      applyThemeColors(savedTheme);

      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('Service Worker registered successfully:', registration);

      // Listen for service worker updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New service worker is available
              console.log('New service worker available');
              // You could show a notification to the user here
            }
          });
        }
      });

      // Handle service worker messages
      navigator.serviceWorker.addEventListener('message', event => {
        console.log('Message from service worker:', event.data);
      });
    } catch (registrationError) {
      console.error('SW registration failed:', registrationError);
    }
  });
}
